export enum TeethArchPosition {
  UPPER = 'UPPER',
  LOWER = 'LOWER',
  BOTH = 'BOTH',
  BOTH_OPEN = 'BOTH_OPEN'
}
